import { useState } from "react";
import { Col, Row, Drawer, Image } from "antd";
import jumplogicon from "../../assets/jumplog.png";
import { useNavigate } from "react-router";
import { useLocation } from "react-router-dom";
import icon1 from "../../assets/icon1.png";

import { MdMenu } from "react-icons/md";
const SideMenu = () => {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const showDrawer = () => {
    setOpen(true);
  };

  const onClose = () => {
    setOpen(false);
  };

  const location = useLocation();
  return (
    <>
      <Row>
        <Col xs={0} md={0} lg={0} xl={24}>
          <div className="side-menu">
            <div
              className={`vector-one-parent ${
                location.pathname === "/" ||
                location.pathname === "/" ||
                location.pathname === "/"
                  ? "active"
                  : ""
              }`}
            >
              <Image
                preview={false}
                alt={"Failed to load image"}
                src={icon1}
                className="vector-one-icon"
              />
              <div
                className="my-profile"
                style={{ cursor: "pointer" }}
                onClick={() => navigate("/")}
              >
                Upcoming Bookings
              </div>
            </div>
            {/* <div
              className={`gift-cards-text-parent ${
                location.pathname.includes("/paymentLogs") ? "active" : ""
              }`}
            >
              <Image
                preview={false}
                alt={"Failed to load image"}
                src={jumplogicon}
                className="vector-one-icon"
              />
              <div
                className="jump-reservation-logs"
                style={{ cursor: "pointer" }}
                onClick={() => navigate("/paymentLogs")}
              >
                Payment Logs
              </div>
            </div>
            <div
              className={`gift-cards-text-parent ${
                location.pathname.includes("/businessHours") ? "active" : ""
              }`}
            >
              <Image
                preview={false}
                alt={"Failed to load image"}
                src={jumplogicon}
                className="vector-one-icon"
              />
              <div
                className="jump-reservation-logs"
                style={{ cursor: "pointer" }}
                onClick={() => navigate("/businessHours")}
              >
                Business Hours
              </div>
            </div> */}
            <div
              className={`gift-cards-text-parent ${
                location.pathname.includes("/vehicleView") ||
                location.pathname.includes("/vehicleEdit")
                  ? "active"
                  : ""
              }`}
            >
              <Image
                preview={false}
                alt={"Failed to load image"}
                src={jumplogicon}
                className="vector-one-icon"
              />
              <div
                className="jump-reservation-logs"
                style={{ cursor: "pointer" }}
                onClick={() => navigate("/vehicleView")}
              >
                My Car
              </div>
            </div>
            <div
              className={`gift-cards-text-parent ${
                location.pathname === "/ride" ? "active" : ""
              }`}
            >
              <Image
                preview={false}
                alt={"Failed to load image"}
                src={jumplogicon}
                className="vector-one-icon"
              />
              <div
                className="jump-reservation-logs"
                style={{ cursor: "pointer" }}
                onClick={() => navigate("/ride")}
              >
                Bookings
              </div>
            </div>
            <div
              className={`gift-cards-text-parent ${
                location.pathname.includes("/historyBookings") ||
                location.pathname.includes("completedBooking")
                  ? "active"
                  : ""
              }`}
            >
              <Image
                preview={false}
                alt={"Failed to load image"}
                src={jumplogicon}
                className="vector-one-icon"
              />
              <div
                className="jump-reservation-logs"
                style={{ cursor: "pointer" }}
                onClick={() => navigate("/historyBookings")}
              >
                History Bookings
              </div>
            </div>
          </div>
        </Col>
        <Col xs={24} md={24} lg={24} xl={0}>
          <>
            <MdMenu
              style={{ fontSize: 26, color: "#000" }}
              onClick={showDrawer}
            />
            <Drawer placement="right" onClose={onClose} open={open}>
              <div className="side-menu">
                <div
                  className={`vector-one-parent ${
                    location.pathname === "/dashboard" ||
                    location.pathname === "/dashboard" ||
                    location.pathname === "/dashboard"
                      ? "active"
                      : ""
                  }`}
                >
                  <Image
                    preview={false}
                    alt={"Failed to load image"}
                    src={icon1}
                    className="vector-one-icon"
                  />
                  <div
                    className="my-profile"
                    style={{ cursor: "pointer" }}
                    onClick={() => navigate("/")}
                  >
                    Upcoming Bookings
                  </div>
                </div>
                {/* <div
              className={`gift-cards-text-parent ${
                location.pathname.includes("/paymentLogs") ? "active" : ""
              }`}
            >
              <Image
                preview={false}
                alt={"Failed to load image"}
                src={jumplogicon}
                className="vector-one-icon"
              />
              <div
                className="jump-reservation-logs"
                style={{ cursor: "pointer" }}
                onClick={() => navigate("/paymentLogs")}
              >
                Payment Logs
              </div>
            </div>
            <div
              className={`gift-cards-text-parent ${
                location.pathname.includes("/businessHours") ? "active" : ""
              }`}
            >
              <Image
                preview={false}
                alt={"Failed to load image"}
                src={jumplogicon}
                className="vector-one-icon"
              />
              <div
                className="jump-reservation-logs"
                style={{ cursor: "pointer" }}
                onClick={() => navigate("/businessHours")}
              >
                Business Hours
              </div>
            </div> */}
                <div
                  className={`gift-cards-text-parent ${
                    location.pathname.includes("/vehicleView") ? "active" : ""
                  }`}
                >
                  <Image
                    preview={false}
                    alt={"Failed to load image"}
                    src={jumplogicon}
                    className="vector-one-icon"
                  />
                  <div
                    className="jump-reservation-logs"
                    style={{ cursor: "pointer" }}
                    onClick={() => navigate("/vehicleView")}
                  >
                    My Car
                  </div>
                </div>
                <div
                  className={`gift-cards-text-parent ${
                    location.pathname === "/ride" ? "active" : ""
                  }`}
                >
                  <Image
                    preview={false}
                    alt={"Failed to load image"}
                    src={jumplogicon}
                    className="vector-one-icon"
                  />
                  <div
                    className="jump-reservation-logs"
                    style={{ cursor: "pointer" }}
                    onClick={() => navigate("/ride")}
                  >
                    Bookings
                  </div>
                </div>
                <div
                  className={`gift-cards-text-parent ${
                    location.pathname.includes("/historyBookings") ||
                    location.pathname.includes("completedBooking")
                      ? "active"
                      : ""
                  }`}
                >
                  <Image
                    preview={false}
                    alt={"Failed to load image"}
                    src={jumplogicon}
                    className="vector-one-icon"
                  />
                  <div
                    className="jump-reservation-logs"
                    style={{ cursor: "pointer" }}
                    onClick={() => navigate("/historyBookings")}
                  >
                    History Bookings
                  </div>
                </div>
              </div>
            </Drawer>
          </>
        </Col>
      </Row>
    </>
  );
};

export default SideMenu;
